import {
  _,
  $,
  Backbone,
  CountryList,
  Radio,
  Foundation,
  moment,
  Datepicker,
} from "../../../vendor";
import { Backform, Dependencies, Biscuit, Uri, Notification, FormatHelper } from "../../utils";
import Inboomai18n from "../../utils/Inboomai18n";
import { DynamoDB } from "aws_js";
import InboomaBaseView from "../InboomaBaseView";
import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

import User from "../../models/User";
import * as FileSaver from "../../../vendor/FileSaver";
import Order from "../../models/Order";
import Users from "../../collections/Users";
import Contingents from "../../collections/Contingents";
import VoucherTypes from "../../collections/VoucherTypes";
import Vouchers from "../../collections/Vouchers";

import VCard from "../users/VCard";
import ReservationsList from "./ReservationForm/ReservationsList";
//import OffCanvasUsersForm from '../../users/OffCanvasUsersForm'

import OffCanvasOrdersFormTpl from "../../templates/orders/OffCanvasOrdersFormTpl.html";
import { getApiHost } from "../../Sync";
import { getDocHandler } from "../../utils/Helper";
import { getContentModifications } from "../../App";
import t from "../../react/helpers/t";

const a = "${a}";

export default InboomaBaseView.extend({
  template: OffCanvasOrdersFormTpl,
  el: "#inb-off-canvas",
  parentView: "reservations/orders",

  skipValidation: true,

  _orderTabs: [
    { id: "order-form-invoice-address-edit", saved: true, exists: false },
    { id: "order-form-end-address-edit", saved: true, exists: false },
    { id: "order-form-start-address-edit", saved: true, exists: false },
    { id: "order-form-service-edit", saved: true, exists: false },
    { id: "order-form-tags-edit", saved: true, exists: false },
  ],

  _tasks: [],

  modelEvents: {
    "change:status": "_changeOrderStatus",
    "change:types": "_changeOrderTypes",
    "change:user_id": "_changeOrderUser",
    "change:price": "_renderNewPrice",
    "change:order_addresses": "_updateOrderAddresses",
  },

  templateContext() {
    return {
      moment,
      _exchangeLabel: (value) => {
        let cm = getContentModifications();

        if (cm.labels != null) {
          if (cm.labels[value] !== undefined) {
            return cm.labels[value];
          }
        }
        return value;
      },
      _tasks: this._tasks,
      isDelivery: (val) => {
        if (val !== null && val != "") {
          let tags = val.split(",");
          let result = false;
          _.each(tags, function (value, k) {
            if (value.trim() === "Anlieferungen") {
              result = true;
            }
          });
          return result;
        }
        return false;
      },
      Biscuit,

      hasTaskPermission: (val) => {
        const role = Biscuit.get("user.role");
        if (role == "user" && val == "write") return false;
        if (role == "user" && val == "edit") return false;
        return true;
      },
      client_id: Biscuit.get("user.client_id"),
    };
  },
  behaviors: [
    {
      behaviorClass: OffCanvasBehavior,
      closeAfterSave: false,
      _exchangeLabel: (value) => {
        let cm = getContentModifications();

        if (cm.labels != null) {
          if (cm.labels[value] !== undefined) {
            return cm.labels[value];
          }
        }
        return value;
      },
      extraHeaderRegionContent: `
          <%      let lastMessage = null;
          if (typeof messages !== 'undefined'){
                _.each(messages,function(message){
                     lastMessage=message;
                  
                  });
           }
           if (lastMessage !== null && typeof lastMessage.created !== 'undefined'){ %>
               | <%= t('order_executed_at_${a}_with_active_status',{a:moment(lastMessage.created).format('Do MMMM YYYY, HH:mm')}) %>
          <% } else if (typeof executed !== 'undefined' && executed !== '' && executed !== null) { %>
             | <%= t('order_executed_at_${a}_with_active_status',{a:moment(executed).format('Do MMMM YYYY, HH:mm')}) %>
          <% }
          if (Biscuit.get('client.showRightOfWithdrawalFields') == 'true') { %>
           | <%= t(_exchangeLabel('waiveRightsOfWithdrawal')) + ': ' + moment(waiveRightOfWithdrawal).format('Do MMMM YYYY, HH:mm') %>
           <% } %>`,
      beforeCanvasClose: (view) => {
        // @todo Use actual this.model.get('reservations').models.length
        // instead of counting UI elements (which was done due to a former bug in behavior.offcanvas)
        const reservations_count = view.$el
          .find(".accordion-item")
          .not(".is-new-reservation").length;

        if (view.model.get("id") !== "" && reservations_count === 0) {
          if (confirm(view.t("order_empty_remove"))) {
            view.model.destroy({
              success(model, repsonse) {
                new Notification({
                  message: view.t("removed_${a}", { a: view.t("order") }, "capital"),
                  duration: 5000,
                  closeable: true,
                  icon: "fi fi-trash",
                });
              },
            });
          }
        }
        // update tag list in sidebar filter
        $("#order-sidebar-tags-update-btn").trigger("click");

        // remove event listener from document
        document.onkeydown = null;
        const vcardLink = document.getElementById("inb-order-vcard-link");
        const vcardCloseBtn = document.getElementById("inb-vcard-close-btn");
        if (vcardLink) vcardLink.removeEventListener("click", view._toggleVCard);
        if (vcardCloseBtn) vcardCloseBtn.removeEventListener("click", view._toggleVCard);

        return false;
      },
      beforeSave: (model, view) => {
        model.set("client_id", Number(Biscuit.get("user.client_id")));

        delete model.attributes.timespan_begin;
        delete model.attributes.timespan_end;
      },
      afterSaveSuccess: (model, view, response) => {
        // Here we assume that an order can NOT be edited
        // afterwards. Check for other use-cases.
        new Notification({
          message:
            view.t("saved_${a}", { a: view.t("order") }, "capital") + " #" + model.get("order_nbr"),
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-check",
        });

        if (model.get("id") === "") {
          view.$el.fadeOut("slow");
        }

        const users = Radio.channel("users").request("get:data");

        users.fetchById(model.get("user_id"), function (user) {
          model.set("user", user.toJSON());
          view.model = new Order(model.toJSON());

          view.collection.set(view.model, {
            add: true,
            merge: true,
            remove: false,
          });
          Backbone.history.navigate("orders/" + view.model.get("id") + "/edit");
          view._render();
        });
      },
      afterSaveError: (model, view) => {
        new Notification({
          message: view.t("request_error", null, "capital"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });
      },
    },
  ],

  ui: {
    executeOrderBtn: "#execute-order-7",
    submitOrderStatusBtn: "#submit-order-status-7",
    addPaymentBtn: "#add-payment",
    reservationsListRegion: "#orders-reservations-accordion",
    ordersForm: "#orders-form",
    dateDeliverField: "#inb-order-deliver-date",
    dateCollectField: "#inb-order-collect-date",
    timeDeliverField: "#inb-order-deliver-time",
    timeCollectField: "#inb-order-collect-time",
  },

  events: {
    "click @ui.executeOrderBtn": "_executeOrder",
    "click .inb-reservation__pdf": "_printRentalContract",
    "click .inb-delivery__pdf": "_printRentalContractDelivery",
    "click @ui.submitOrderStatusBtn": "_submitOrderStatus",
    "click #add-reservation": "_addReservation",
    "click .accordion-item": "_toggleHideExecuteBtn",
    "click @ui.addPaymentBtn": "_openPayment",
    "click .trigger_popup_form_data": "_showPopUp",
    // order tag events
    "click .tag-remove-icon": "_removeTag",
    "change #offcanvas-order-tag-select": "_addTag",
    "change #offcanvas-order-tag-box-input": "_addCustomTag",
    "click #offcanvas-order-tag-box": "_editTag",
    // order tab events
    "click .order-address-bar": "_editOrderTabClicked",
    "click .inb-order-form-address-close": "_closeOrderTabClicked",
    "click .inb-order-form-address-save": "_saveOrderTabClicked",
    "change .order-address-field": "_orderTabChanged",
    "change @ui.timeDeliverField": "_deliverTimeChanged",
    "change @ui.timeCollectField": "_collectTimeChanged",
  },

  _printRentalContract(target) {
    // show warning if rental contract should be confirmed
    const that = this;

    let showWarning = false;

    _.each(this.model.get("reservations").models, function (reservation) {
      if (
        moment(reservation.get("modified")).format("x") >
          moment(that.model.get("executed")).format("x") &&
        that.model.get("executed") != null
      ) {
        // showWarning = true;
      }
    });

    // proof if status is executed or paid
    if (this.model.get("status") != "confirmed" && this.model.get("status") != "paid") {
      showWarning = false;
    }

    if (showWarning === true) {
      if (confirm(this.t("rental_contract_warning"))) {
        const t = $(target.currentTarget),
          rid = t.closest(".inb-reservation").attr("data-inb-reservation");

        let ref = "" + getApiHost();
        ref = ref.slice(0, -4) + "/rental_contract/" + rid;
        window.open(ref, "_blank");
      }
    } else {
      const t = $(target.currentTarget),
        rid = t.closest(".inb-reservation").attr("data-inb-reservation");

      /*let ref = "" + getApiHost();
            ref = ref.slice(0, -4) + "/rental_contract/" + rid + "/1";
            window.open(ref,'_blank');*/
      getDocHandler(
        "/rental_contract/" + rid + "/1",
        "GET",
        "application/pdf",
        this.t("reservation") + "-" + reservation.order.order_nbr + ".pdf",
        "",
        rid,
      );
    }

    // Request rental contract as PDF from backend, then trigger download dialogue to browser
    /*
        const t = $(target.currentTarget),
              rid = t.closest('.inb-reservation').attr('data-inb-reservation');

        // FileSaver bereits oben importiert

        // Fallback on native ajax request as more flexible when setting certain parameters
        const xmlHttp = new XMLHttpRequest();

        xmlHttp.open("GET", getApiHost() + '/reservations/getRentalContract/' + rid, true);

        xmlHttp.setRequestHeader('Accept', 'application/json')
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'))
        xmlHttp.responseType = "blob";
        xmlHttp.onload = function() {

          if (xmlHttp.status === 500) {
            alert('mietvertrag_download_error')
            return;
          }

          const blob = new Blob([xmlHttp.response], { type: 'application/pdf' });

          FileSaver.saveAs(blob, "rental_contract_"+ rid +".pdf");

        };

        xmlHttp.send(null);
        */
  },

  _printRentalContractDelivery(target) {
    // show warning if rental contract should be confirmed
    const that = this;

    /* let ref = "" + getApiHost();
            ref = ref.slice(0, -4) + "/ticket/" + that.model.get('id');
            window.open(ref,'_blank');*/
    getDocHandler(
      "/ticket/" + that.model.get("id"),
      "GET",
      "application/pdf",
      t("booking") + "-" + that.model.get("order").get("order_nbr") + ".pdf",
      "",
      that.model.get("id"),
    );
  },

  _renderNewPrice() {
    // @todo As input field becomes/should be re-rendered by Backform,
    // this method is somehow obsolete
    this.$el.find(".inb-form-group.price input").html(this.model.get("price"));
  },

  _hasAnyUnsavedReservations() {
    return this.$el.find(".reservation-requires-save").not(".hide").length >= 1;
  },

  _toggleHideExecuteBtn(ev) {
    if (ev) {
      ev.preventDefault();
    }

    if (typeof this._ui === "undefined") return;

    if (this._hasAnyUnsavedReservations()) {
      // ...opening
      this.getUI("executeOrderBtn").addClass("hollow");
    } else {
      // ...closing
      this.getUI("executeOrderBtn").removeClass("hollow");
    }
  },

  _openPayment(ev) {
    ev.stopImmediatePropagation(); // prevent doubled execution

    if (typeof this.options.context !== "undefined") {
      if (this.options.context == "reservations/reservationsList") {
        this.$("#inb-ordersform-abort-button").trigger("click"); // close this canvas
        Backbone.history.navigate(
          "orders/" + this.model.get("id") + "/addpaymentfromreservations",
          { trigger: true },
        );
      } else if (this.options.context == "reservations/orders") {
        this.$("#inb-ordersform-abort-button").trigger("click"); // close this canvas
        Backbone.history.navigate("orders/" + this.model.get("id") + "/addpaymentfromorders", {
          trigger: true,
        });
      } else if (this.options.context == "transactionsList") {
        this.$("#inb-ordersform-abort-button").trigger("click"); // close this canvas
        Backbone.history.navigate("orders/" + this.model.get("id") + "/addpayment", {
          trigger: true,
        });
      } else {
        this.$("#inb-ordersform-abort-button").trigger("click"); // close this canvas
        Backbone.history.navigate("orders/" + this.model.get("id") + "/addpaymentfromorderedit", {
          trigger: true,
        });
      }
    } else {
      this.$("#inb-ordersform-abort-button").trigger("click"); // close this canvas
      Backbone.history.navigate("orders/" + this.model.get("id") + "/addpaymentfromorderedit", {
        trigger: true,
      });
    }

    return true;
  },

  _showPopUp(ev) {
    ev.stopImmediatePropagation();
    let output = `
          <html>
            <head>
                <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">
                <title>${this.t("form_data")}</title>
                <style type="text/css">
                    body { font-family: "Open Sans",Helvetica,Arial,sans-serif; }
                    hode, html, table, thead { width: 100%; }
                    h4 { font-size: 18px; }
                    .printSpacer { height:100px; }
                </style>
                </head>
            <div>${this.model.get("form_data")}
          
            </body>
            </html>`;
    let rV = -1; // Return value assumes failure.

    if (navigator.appName == "Microsoft Internet Explorer" || navigator.appName == "Netscape") {
      let uA = navigator.userAgent;
      let rE = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");

      if (rE.exec(uA) != null) {
        rV = parseFloat(RegExp.$1);
      } else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        rV = 11;
      }
    }

    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const newWindowIn = window.open("", "", "height=700,width=674");

    newWindowIn.document.body.innerHTML = "";
    newWindowIn.document.body.innerHTML = output;
    if (rV >= 10 || isChrome) {
      newWindowIn.focus(); // necessary for IE >= 10*
    } else {
      // e.g. Firefox
      setTimeout(() => {
        newWindowIn.opener.focus();
      }, 0);
    }
    return true;
  },

  _executeOrder(ev) {
    ev.stopImmediatePropagation(); // stop any further handling of ev

    if (this._hasAnyUnsavedReservations()) {
      if (typeof this._alreadyShowedExecuteWarning !== "undefined") {
        delete this._alreadyShowedExecuteWarning;
        return;
      }

      this._alreadyShowedExecuteWarning = true;
      alert(this.t("warning_reservation_in_progress"));
    } else {
      const that = this;

      this._alreadyExecuted = true; // marking that status has been changed by pressing execute button

      this.model.executeOrder().then((model) => {
        new Notification({
          message: that.t("order_successfully_executed"),
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-mail",
        });

        that.model.set("executed", moment().toISOString()); // Hide button
        that.model.set("status", "confirmed"); // Sync with backend
        that.model.trigger("changed");

        delete that._alreadyExecuted;

        // Update "executed at" timestamp
        that.headerRegionView.render();

        that._reservationsList.render();
      });
    }
  },

  _submitOrderStatus(ev) {
    ev.preventDefault();

    if (this._hasAnyUnsavedReservations()) {
      if (typeof this._alreadyShowedExecuteWarning !== "undefined") {
        delete this._alreadyShowedExecuteWarning;
        return;
      }

      this._alreadyShowedExecuteWarning = true;
      alert(this.t("warning_reservation_in_progress"));
    } else {
      const that = this;

      if (typeof this._alreadyExecuted !== "undefined") {
        return;
      }

      this._alreadyExecuted = true;

      this.model.submitOrderStatus().then((model) => {
        new Notification({
          message: that.t("order_status_successfully_submitted"),
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-mail",
        });
        let response = JSON.parse(model);
        that.model.set("messages", response.messages);
        that.headerRegionView.render();
        delete that._alreadyExecuted;
      });
    }
  },

  /**
   * Adds a floating customer-info-popup next to username-field
   */
  _setVCard() {
    this.$el.find("#order-vcard").remove();

    if (typeof this.user === "undefined" || this.model.get("user") === null) {
      return;
    }

    this.$el.find(".inb-form-group.user_id").attr("data-toggle", "order-vcard").append(`
              <div
                  id="order-vcard"
                  class="order-vcard-dropdown hide"
                  data-position="bottom"
                  data-alignment="left"
                  style="min-width:400px;position:fixed;z-index:102;background-color:white;box-shadow:2px 2px 5px #999;"></div>
              `);

    new VCard({
      el: this.$el.find(".order-vcard-dropdown"),
      model: this.user,
    });

    if (this.model.get("id") !== "") {
      if (typeof this._vcard !== "undefined") {
        this._vcard._destroy();
      }

      // Make VCard toggable
      //this._vcard = new Foundation.Dropdown(this.$el.find('#order-vcard'));
    }
  },

  /********************************************** order tabs **************************************************/
  /*
   * this simply opens / shows the order tab
   * without doing anything else
   */
  _openOrderTab(tabElement) {
    $(tabElement).removeClass("inactive");
    $(tabElement).addClass("active");

    $(this._getContentBoxOfOrderTab(tabElement)).removeClass("hide");
  },

  /*
   * this closes / hides a tab if tab is saved or user confirms closing
   */
  _closeOrderTab(tabElement, callback) {
    var closed = true;

    for (var i = 0; i < this._orderTabs.length; i++) {
      if (!this._orderTabs[i].saved && this._orderTabs[i].id == tabElement.id) {
        // tab has unsaved changes
        var that = this;
        if (confirm("Achtung, Änderungen werden hiermit verworfen! Fortfahren?")) {
          // reset tab
          that._updateOrderAddresses();
        } else {
          closed = false;
        }
      }
    }
    if (closed) {
      $(this._getContentBoxOfOrderTab(tabElement)).addClass("hide");
      $(tabElement).removeClass("active");
    }
    if (typeof callback === "function") callback(closed);
  },

  // simply returns the container of the content that belongs to the tab
  _getContentBoxOfOrderTab(tabElement) {
    switch (tabElement.id) {
      case "order-form-invoice-address-edit":
        return document.getElementById("order-form-invoice-address");
      case "order-form-start-address-edit":
        return document.getElementById("order-form-start-address");
      case "order-form-end-address-edit":
        return document.getElementById("order-form-end-address");
      case "order-form-service-edit":
        return document.getElementById("order-form-service-container");
      case "order-form-tags-edit":
        return document.getElementById("order-form-tags-container");
    }
  },

  // simply returns the tab bar element that belongs to the tab content box
  _getOrdertabOfContentBox(contentBox) {
    switch (contentBox.id) {
      case "order-form-invoice-address":
        return document.getElementById("order-form-invoice-address-edit");
      case "order-form-start-address":
        return document.getElementById("order-form-start-address-edit");
      case "order-form-end-address":
        return document.getElementById("order-form-end-address-edit");
      case "order-form-service-container":
        return document.getElementById("order-form-service-edit");
      case "order-form-tags-container":
        return document.getElementById("order-form-tags-edit");
    }
  },

  // return the currently opened tab or null if no tab is open
  _getOpenOrderTab() {
    const tabContainer = document.getElementById("order-form-address-bar-container");
    for (var elem, i = 0; i < tabContainer.childNodes.length; i++) {
      elem = tabContainer.childNodes[i];
      if (
        elem.tagName == "DIV" &&
        $(elem).hasClass("order-address-bar") &&
        $(elem).hasClass("active")
      ) {
        return elem;
      }
    }
    return null;
  },

  _editOrderTabClicked(ev) {
    ev.stopImmediatePropagation();

    // get the right order tab
    let tab = ev.target.parentNode;
    if ($(ev.target).hasClass("order-address-bar")) tab = ev.target;

    // proof if tab is already open
    if ($(tab).hasClass("active")) return;

    var openTab = this._getOpenOrderTab();
    if (openTab == null) {
      // no tab open - open new tab
      this._openOrderTab(tab);
    } else {
      // try to close tab (maybe there are unsaved changed and user aborts)
      var that = this;
      this._closeOrderTab(openTab, function (closed) {
        if (closed) {
          that._openOrderTab(tab);
        }
      });
    }
  },

  _closeOrderTabClicked(ev) {
    ev.stopImmediatePropagation();

    // get right tab element
    var contentBox = ev.target.parentNode.parentNode;
    if ($(ev.target).hasClass("fi") || $(ev.target).hasClass("inb-icon"))
      contentBox = contentBox.parentNode;

    var tabElement = this._getOrdertabOfContentBox(contentBox);
    this._closeOrderTab(tabElement);
  },

  _saveOrderTabClicked(ev) {
    ev.stopImmediatePropagation(); // prevent double execution

    // get the right tab element
    var tabElement,
      addressContainer = ev.target.parentNode.parentNode;
    if ($(ev.target).hasClass("fi") || $(ev.target).hasClass("inb-icon"))
      addressContainer = addressContainer.parentNode;
    tabElement = this._getOrdertabOfContentBox(addressContainer);

    // proof if there are changes
    var tabIndex;
    for (var i = 0; i < this._orderTabs.length; i++) {
      if (this._orderTabs[i].id == tabElement.id) {
        if (this._orderTabs[i].saved) {
          // order address already saved
          console.log("address already saved - do nothing");
          return;
        } else {
          tabIndex = i;
        }
      }
    }

    // search address in model, set address data, send patch to api and set state 'saved' local
    var address, date, time;
    const that = this;
    switch (addressContainer.id) {
      case "order-form-invoice-address":
        for (var j = 0; j < this.model.attributes.order_addresses.length; j++) {
          if (this.model.attributes.order_addresses[j].type == "invoice") {
            // found existing invoice address -> update values
            address = this.model.attributes.order_addresses[j];
          }
        }
        if (address === undefined) {
          // no invoice address found -> create new one
          address = { type: "invoice" };
          this.model.attributes.order_addresses.push(address);
        }
        // update order address
        address.organization = document.getElementById("order-invoice-address-organization").value;
        address.name = document.getElementById("order-invoice-address-recipient").value;
        address.street = document.getElementById("order-invoice-address-street").value;
        address.number = document.getElementById("order-invoice-address-housenumber").value;
        address.city = document.getElementById("order-invoice-address-city").value;
        address.postal = document.getElementById("order-invoice-address-zip").value;
        address.country = document.getElementById("order-invoice-address-country").value;

        this.model.save(
          { order_addresses: this.model.attributes.order_addresses },
          {
            patch: true,
            silent: true,
            success(model, response) {
              console.log("success: ", response);
              that._orderTabs[tabIndex].saved = true;
              that.model._statusChangeInProgress = false;
              that.model.trigger("changed");
              that._render();
            },
          },
        );
        break;

      case "order-form-start-address":
        for (var j = 0; j < this.model.attributes.order_addresses.length; j++) {
          if (this.model.attributes.order_addresses[j].type == "begin") {
            // found existing invoice address -> update values
            address = this.model.attributes.order_addresses[j];
          }
        }
        if (address === undefined) {
          // no invoice address found -> create new one
          address = { type: "begin" };
          this.model.attributes.order_addresses.push(address);
        }

        // update order address
        date = this.datepickerDeliver.getMoment();
        time = document.getElementById("inb-order-deliver-time").value;
        if (time.length == 0) address._dateTimeBegin = "";
        else address._dateTimeBegin = moment(date).format("yyyy-MM-DD") + " " + time;
        address.organization = document.getElementById("order-start-address-organization").value;
        address.name = document.getElementById("order-start-address-recipient").value;
        address.street = document.getElementById("order-start-address-street").value;
        address.number = document.getElementById("order-start-address-housenumber").value;
        address.city = document.getElementById("order-start-address-city").value;
        address.postal = document.getElementById("order-start-address-zip").value;
        address.country = document.getElementById("order-start-address-country").value;
        address.note = document.getElementById("order-start-address-note").value;

        this.model.save(
          { order_addresses: this.model.attributes.order_addresses },
          {
            patch: true,
            silent: true,
            success(model, response) {
              console.log("success: ", response);
              that._orderTabs[tabIndex].saved = true;
              that.model._statusChangeInProgress = false;
              that.model.trigger("changed");
              that._render();
            },
          },
        );
        break;

      case "order-form-end-address":
        for (var j = 0; j < this.model.attributes.order_addresses.length; j++) {
          if (this.model.attributes.order_addresses[j].type == "end") {
            // found existing invoice address -> update values
            address = this.model.attributes.order_addresses[j];
          }
        }
        if (address === undefined) {
          // no invoice address found -> create new one
          address = { type: "end" };
          this.model.attributes.order_addresses.push(address);
        }
        // update order address
        date = this.datepickerCollect.getMoment();
        time = document.getElementById("inb-order-collect-time").value;
        if (time.length == 0) address._dateTimeEnd = "";
        else address._dateTimeEnd = moment(date).format("yyyy-MM-DD") + " " + time;
        address.organization = document.getElementById("order-end-address-organization").value;
        address.name = document.getElementById("order-end-address-recipient").value;
        address.street = document.getElementById("order-end-address-street").value;
        address.number = document.getElementById("order-end-address-housenumber").value;
        address.city = document.getElementById("order-end-address-city").value;
        address.postal = document.getElementById("order-end-address-zip").value;
        address.country = document.getElementById("order-end-address-country").value;

        this.model.save(
          { order_addresses: this.model.attributes.order_addresses },
          {
            patch: true,
            silent: true,
            success(model, response) {
              console.log("success: ", response);
              that._orderTabs[tabIndex].saved = true;
              that.model._statusChangeInProgress = false;
              console.log(that._order);
              that._render();
            },
          },
        );
        break;
    }
  },

  _orderTabChanged(ev) {
    ev.stopImmediatePropagation();

    var contentContainer = ev.target.parentNode.parentNode.parentNode;

    if (contentContainer.className.indexOf("inb-order-address-container") < 0)
      contentContainer = contentContainer.parentNode;
    var tabElement = this._getOrdertabOfContentBox(contentContainer);

    for (var i = 0; i < this._orderTabs.length; i++) {
      if (this._orderTabs[i].id == tabElement.id) {
        this._orderTabs[i].saved = false;
      }
    }
  },

  /*
   * function to create country list
   * this also fills select boxes for countries
   */
  _setAddressCountries() {
    var country_list = [
      {
        label: "",
        value: "",
      },
    ];
    const language = Biscuit.get("user.lang").split("_");

    let index = 0,
      index_counter = 0;

    _.each(CountryList.getNames(language[0]), (key, val) => {
      country_list.push({
        label: key,
        value: val,
      });
      index_counter++;

      if (key == Biscuit.get("client.country")) {
        index = index_counter;
      }
    });

    var invoiceCountry = document.getElementById("order-invoice-address-country"),
      endCountry = document.getElementById("order-end-address-country"),
      startCountry = document.getElementById("order-start-address-country");
    for (var opt, i = 0; i < country_list.length; i++) {
      opt = document.createElement("option");
      opt.value = country_list[i].value;
      opt.text = country_list[i].label;
      invoiceCountry.appendChild(opt);
      endCountry.appendChild(opt.cloneNode(true));
      startCountry.appendChild(opt.cloneNode(true));
    }
    invoiceCountry.selectedIndex = index;
    endCountry.selectedIndex = index;
    startCountry.selectedIndex = index;
  },

  /*
   * fill fields of order addresses
   * (they do not belong to order form because of styling issues)
   */
  _updateOrderAddresses() {
    var invoiceStored = false,
      startStored = false,
      endStored = false;

    // fill address fields if address type exists (has been already stored)
    for (var address, i = 0; i < this.model.attributes.order_addresses.length; i++) {
      address = this.model.attributes.order_addresses[i];

      switch (address.type) {
        case "invoice":
          document.getElementById("order-invoice-address-organization").value =
            address.organization;
          document.getElementById("order-invoice-address-recipient").value = address.name;
          document.getElementById("order-invoice-address-street").value = address.street;
          document.getElementById("order-invoice-address-housenumber").value = address.number;
          document.getElementById("order-invoice-address-city").value = address.city;
          document.getElementById("order-invoice-address-zip").value = address.postal;
          // select country
          var sel = document.getElementById("order-invoice-address-country");
          for (var j = 0; j < sel.options.length; j++) {
            if (sel.options[j].value == address.country) {
              sel.selectedIndex = j;
              j = sel.options.length;
            }
          }
          for (var j = 0; j < this._orderTabs.length; j++) {
            if (this._orderTabs[j].id == "order-form-invoice-address-edit") {
              this._orderTabs[j].exists = true;
              invoiceStored = true;
            }
          }
          break;
        case "end":
          if (address._dateTimeEnd !== undefined && address._dateTimeEnd != null) {
            this.datepickerCollect.setMoment(moment(address._dateTimeEnd));
            document.getElementById("inb-order-collect-date").value = moment(
              address._dateTimeEnd,
            ).format("D. MMMM YYYY");
            document.getElementById("inb-order-collect-time").value = moment(
              address._dateTimeEnd,
            ).format("HH:mm");
          }
          document.getElementById("order-end-address-organization").value = address.organization;
          document.getElementById("order-end-address-recipient").value = address.name;
          document.getElementById("order-end-address-street").value = address.street;
          document.getElementById("order-end-address-housenumber").value = address.number;
          document.getElementById("order-end-address-city").value = address.city;
          document.getElementById("order-end-address-zip").value = address.postal;
          // select country
          var sel = document.getElementById("order-end-address-country");
          for (var j = 0; j < sel.options.length; j++) {
            if (sel.options[j].value == address.country) {
              sel.selectedIndex = j;
              j = sel.options.length;
            }
          }
          for (var j = 0; j < this._orderTabs.length; j++) {
            if (this._orderTabs[j].id == "order-form-end-address-edit") {
              this._orderTabs[j].exists = true;
              endStored = true;
            }
          }
          break;
        case "begin":
          if (address._dateTimeBegin !== undefined && address._dateTimeBegin != null) {
            this.datepickerDeliver.setMoment(moment(address._dateTimeBegin));
            document.getElementById("inb-order-deliver-date").value = moment(
              address._dateTimeBegin,
            ).format("D. MMMM YYYY");
            document.getElementById("inb-order-deliver-time").value = moment(
              address._dateTimeBegin,
            ).format("HH:mm");
          }
          document.getElementById("order-start-address-note").value = address.note;
          document.getElementById("order-start-address-organization").value = address.organization;
          document.getElementById("order-start-address-recipient").value = address.name;
          document.getElementById("order-start-address-street").value = address.street;
          document.getElementById("order-start-address-housenumber").value = address.number;
          document.getElementById("order-start-address-city").value = address.city;
          document.getElementById("order-start-address-zip").value = address.postal;
          // select country
          var sel = document.getElementById("order-start-address-country");
          for (var j = 0; j < sel.options.length; j++) {
            if (sel.options[j].value == address.country) {
              sel.selectedIndex = j;
              j = sel.options.length;
            }
          }
          for (var j = 0; j < this._orderTabs.length; j++) {
            if (this._orderTabs[j].id == "order-form-start-address-edit") {
              this._orderTabs[j].exists = true;
              startStored = true;
            }
          }
          break;
      }
    }
    if (!invoiceStored) {
      // pre-fill with user address
      for (var i = 0; i < this.users.models.length; i++) {
        if (this.users.models[i].attributes.id == this.model.attributes.user_id) {
          const user = this.users.models[i].attributes;
          const userAddress =
            this.users.models[i].attributes.user_addresses.length > 0
              ? this.users.models[i].attributes.user_addresses[0]
              : {};
          if (user.company !== undefined)
            document.getElementById("order-invoice-address-organization").value = user.company;
          if (user.first_name !== undefined)
            document.getElementById("order-invoice-address-recipient").value = user.first_name;
          if (user.last_name !== undefined && user.first_name !== undefined)
            document.getElementById("order-invoice-address-recipient").value +=
              " " + user.last_name;
          else if (user.last_name !== undefined)
            document.getElementById("order-invoice-address-recipient").value = user.last_name;
          if (userAddress.street !== undefined)
            document.getElementById("order-invoice-address-street").value = userAddress.street;
          if (userAddress.house_number !== undefined)
            document.getElementById("order-invoice-address-housenumber").value =
              userAddress.house_number;
          if (userAddress.city !== undefined)
            document.getElementById("order-invoice-address-city").value = userAddress.city;
          if (userAddress.zip_code !== undefined)
            document.getElementById("order-invoice-address-zip").value = userAddress.zip_code;
          // select country
          if (userAddress.country !== undefined) {
            var sel = document.getElementById("order-invoice-address-country");
            for (var j = 0; j < sel.options.length; j++) {
              if (sel.options[j].value == userAddress.country.substring(0, 2)) {
                sel.selectedIndex = j;
                j = sel.options.length;
              }
            }
          }
        }
      }
    }
    if (!endStored && startStored) {
      // pre-fill end address with start address
      for (var startAddress, i = 0; i < this.model.attributes.order_addresses.length; i++) {
        if (this.model.attributes.order_addresses[i].type == "begin") {
          startAddress = this.model.attributes.order_addresses[i];

          document.getElementById("order-end-address-organization").value =
            startAddress.organization;
          document.getElementById("order-end-address-recipient").value = startAddress.name;
          document.getElementById("order-end-address-street").value = startAddress.street;
          document.getElementById("order-end-address-housenumber").value = startAddress.number;
          document.getElementById("order-end-address-city").value = startAddress.city;
          document.getElementById("order-end-address-zip").value = startAddress.postal;
          // select country
          var sel = document.getElementById("order-end-address-country");
          for (var j = 0; j < sel.options.length; j++) {
            if (sel.options[j].value == startAddress.country) {
              sel.selectedIndex = j;
              j = sel.options.length;
            }
          }
        }
      }
    }
    for (var j = 0; j < this._orderTabs.length; j++) this._orderTabs[j].saved = true;
  },

  /*********************************************** reservations ****************************************************/

  _addReservation(ev) {
    if (ev) {
      ev.preventDefault();
    }

    this.$el.find("#inb-app-empty-order").addClass("hide");

    const that = this;

    if (typeof that._ui !== "undefined") {
      this.getUI("executeOrderBtn").addClass("hollow");
    }

    if (!this.$el.find(".is-new-reservation").length) {
      // Untoggle all open accordion items
      this.$el.find(".accordion-item .accordion-content").addClass("hide");

      const newReservation = this.model.get("reservations").add({
        order_id: this.model.get("id"),
      });

      this._setReservationEvents(newReservation);

      newReservation.set("_requiresSave", true);

      if (typeof that._ui !== "undefined") {
        this.getUI("executeOrderBtn").addClass("hollow");
      }

      this.$el.scrollTop(this.$el.find(".is-new-reservation").offset().top);
    }
  },

  _setReservationEvents(reservation) {
    const that = this;

    reservation.set("_requiresSave", false);

    reservation.on("change:_requiresSave", function () {
      that._toggleHideExecuteBtn();
    });

    reservation.on("change:price", () => {
      // get total price of each reservation
      let resPrice = "",
        i = 0,
        resPriceFields = that.$(".reservation-price");

      _.each(this.model.get("reservations").models, function (reservation) {
        resPrice = reservation.get("price");
        resPriceFields[i++].innerHTML =
          FormatHelper.currencyFormat(Number(resPrice)) + " " + Biscuit.getClientCurrency();
      });

      //  that._recalculateOrderPrice();
    });

    reservation.on("changed", () => {
      let orderBtn = null;

      if (typeof that._ui !== "undefined") {
        orderBtn = that.getUI("executeOrderBtn")[0];
        orderBtn.classList.remove("hollow");
      }

      that.model.updatePrice(() => {
        that.model.trigger("changed");
        // Update "modified at / by" timestamp
        that.headerRegionView.fetchUsersAndRender();
      });

      const reservations_count = that.$(".accordion-item").length;

      if (
        reservations_count >= 1 &&
        typeof that._ui !== "undefined" &&
        orderBtn !== null &&
        (that.model.get("executed") == "" || that.model.get("executed") == null)
      ) {
        orderBtn.classList.remove("hide");
      }
    });
  },

  //------------------------------------------------------------------ tags ---------------------------------------------------//

  _requestAvailableTags() {
    // fetch order tags
    const that = this;
    const RequestHelper = Backbone.Model.extend({
      urlRoot: "/tags?namespace=Orders",
    });

    new RequestHelper(null).fetch({
      success(model, response) {
        if (response.success && response.data.length > 0) {
          // put tags into list of available tags
          for (var i = 0; i < response.data.length; i++) {
            that._availableTags.push(response.data[i]);
          }
          that._setAvailableTags();
          that._loadTagList();
        } else {
          console.log("ERROR: failed to get tags response");
        }
      },
      error(model, response) {
        console.log("Error, could not request tags.");
      },
    });
  },

  _setAvailableTags() {
    // fill list of available tags except already selected tags
    let tagFound,
      tagList = document.getElementById("offcanvas-order-tag-select");

    if (tagList === undefined || tagList == null) return;

    for (var opt, j, i = 0; i < this._availableTags.length; i++) {
      tagFound = false;
      for (j = 0; j < this._selectedTags.length; j++) {
        if (this._selectedTags[j].id == this._availableTags[i].id) {
          tagFound = true;
        }
      }
      if (!tagFound) {
        opt = document.createElement("option");
        opt.text = this._availableTags[i].label;
        opt.value = this._availableTags[i].id;
        tagList.appendChild(opt);
      }
    }
    // fill tag box with already selected tags
    let tagBox = document.getElementById("offcanvas-order-tag-box");
    if (this._selectedTags.length > 0)
      tagBox.insertBefore(
        this._createTagElement(
          this._selectedTags[0].id,
          this._selectedTags[0].label,
          this._selectedTags[0].system,
        ),
        tagBox.childNodes[0],
      );

    for (var i = 1; i < this._selectedTags.length; i++) {
      tagBox.insertBefore(
        this._createTagElement(
          this._selectedTags[i].id,
          this._selectedTags[i].label,
          this._selectedTags[i].system,
        ),
        tagBox.childNodes[tagBox.childNodes.length - 1],
      );
    }
  },

  _loadTagList() {
    const tagBox = document.getElementById("offcanvas-order-tag-box");
    let tagSelect = document.getElementById("offcanvas-order-tag-select");
    let tagArray = this.model.attributes.tags;

    // load order tags
    for (var j = 0, i = 0; i < tagArray.length; i++) {
      var tagElement = this._createTagElement(
        tagArray[i].id,
        tagArray[i].label,
        tagArray[i].system,
      );
      tagBox.appendChild(tagElement);
      console.log("avail: ", this._availableTags);
      for (j = 0; j < this._availableTags.length; j++) {
        if (this._availableTags[j].id == tagArray[i].id) {
          this._selectedTags.push(this._availableTags[j]);
        }
      }
    }

    // remove order tags (already selected tags) from select box
    for (var j = 0, i = 0; i < this._selectedTags.length; i++) {
      for (j = 0; j < tagSelect.options.length; j++) {
        if (tagSelect.options[j].innerHTML == this._selectedTags[i].label) {
          tagSelect.remove(j);
          j = tagSelect.options.length;
        }
      }
    }
  },

  _addTag(ev) {
    ev.stopImmediatePropagation();

    // add value of select box
    var tag_index,
      tag_id = ev.target.options[ev.target.selectedIndex].value;
    var tagBox = document.getElementById("offcanvas-order-tag-box");
    var tagBoxInput = document.getElementById("offcanvas-order-tag-box-input").parentNode;

    for (var i = 0; i < this._availableTags.length; i++) {
      if (this._availableTags[i].id == tag_id) tag_index = i;
    }
    tagBox.insertBefore(
      this._createTagElement(
        tag_id,
        this._availableTags[tag_index].label,
        this._availableTags[tag_index].system,
      ),
      tagBoxInput,
    );
    this._selectedTags.push(this._availableTags[tag_index]);

    // remove tag from select box and unselect everything
    ev.target.remove(ev.target.selectedIndex);
    ev.target.selectedIndex = 0;

    // immediatly add tag to order and save order before close
    this._saveOrderTags();
  },

  _addCustomTag(ev) {
    ev.stopImmediatePropagation();

    var val = ev.target.value;
    var tagBox = document.getElementById("offcanvas-order-tag-box");

    // add tag to tag box
    this._customTagsCount++;
    tagBox.insertBefore(
      this._createTagElement(-this._customTagsCount, val, false),
      ev.target.parentNode,
    );

    // add tag to list of available tags and list of selected tags
    this._availableTags.push({ id: -this._customTagsCount, label: val });
    this._selectedTags.push({ id: -this._customTagsCount, label: val });

    // clear input box
    ev.target.value = "";

    this._saveOrderTags();
  },

  _saveOrderTags() {
    const that = this;
    this.model.save(
      { tag_list: this._createOrderTagList(this._selectedTags) },
      {
        patch: true,
        silent: true,
        success(model, response) {
          console.log("success: ", response);
        },
      },
    );
  },

  _editTag(ev) {
    ev.stopImmediatePropagation();
    // clicked into tag box - set focus on input box
    document.getElementById("offcanvas-order-tag-box-input").focus();
  },

  _removeTag(ev) {
    ev.stopImmediatePropagation();

    const tagBox = document.getElementById("offcanvas-order-tag-box");
    const tagSelect = document.getElementById("offcanvas-order-tag-select");
    const tagContentWrapper = ev.target.parentNode;
    var tagOption = document.createElement("option");

    // search label element, add tag to list of available tags, remove tag from list of selected tags
    for (var i = 0; i < tagContentWrapper.childNodes.length; i++) {
      if (tagContentWrapper.childNodes[i].tagName == "DIV") {
        for (var j = 0; j < tagContentWrapper.childNodes[i].childNodes.length; j++) {
          if (tagContentWrapper.childNodes[i].childNodes[j].tagName == "LABEL") {
            // label element found, create option for select box
            tagOption.text = tagContentWrapper.childNodes[i].childNodes[j].innerHTML;
            tagOption.value = tagContentWrapper.parentNode.getAttribute("tag_id");

            // remove tag from list of selected tags
            for (var k = 0; k < this._selectedTags.length; k++) {
              if (this._selectedTags[k].id == tagContentWrapper.parentNode.getAttribute("tag_id")) {
                this._selectedTags.splice(k, 1);
                tagSelect.add(tagOption);
                tagBox.removeChild(tagContentWrapper.parentNode);
                this._saveOrderTags();
                return;
              }
            }
          }
        }
      }
    }
  },

  _createTagElement(id, label, isSystem) {
    // create and append tag element
    var tagElement = document.createElement("div");
    var tagContent = document.createElement("div");
    isSystem
      ? (tagElement.className = "tag-element system")
      : (tagElement.className = "tag-element");
    tagElement.setAttribute("tag_id", id);
    tagContent.className = "content-wrapper";
    var labelWrapper = document.createElement("div");
    labelWrapper.className = "label-wrapper";
    var tagLabel = document.createElement("label");
    tagLabel.innerHTML = label;
    var tagRemoveIcon = document.createElement("div");
    tagRemoveIcon.className = "tag-remove-icon";
    tagRemoveIcon.innerHTML = "x";

    labelWrapper.appendChild(tagLabel);
    tagContent.appendChild(labelWrapper);
    tagContent.appendChild(tagRemoveIcon);
    tagElement.appendChild(tagContent);

    return tagElement;
  },

  _createOrderTagList(tags) {
    let tagList = "";
    for (var i = 0; i < tags.length; i++) {
      tagList += tags[i].label + ",";
    }
    console.log("taglist: ", tagList);
    return tagList.slice(0, -1);
  },

  _destroyDatepickers() {
    if (typeof this.datepickerDeliver !== "undefined") {
      this.datepickerDeliver.destroy();
    }
    if (typeof this.datepickerCollect !== "undefined") {
      this.datepickerCollect.destroy();
    }
  },

  _datePickerDeliverOnSelect(date, triggerFetch = true) {
    this.getUI("dateDeliverField")[0].value = moment(date).format("D. MMMM YYYY");

    let timeField = this.getUI("timeDeliverField")[0];
    if (timeField.value === undefined || timeField.value == "")
      timeField.value = moment().format("HH:mm");
    this._timeDeliver = timeField.value;
    $(timeField).trigger("change");
  },

  _datePickerCollectOnSelect(date, triggerFetch = true) {
    this.getUI("dateCollectField")[0].value = moment(date).format("D. MMMM YYYY");

    let timeField = this.getUI("timeCollectField")[0];
    if (timeField.value === undefined || timeField.value == "")
      timeField.value = moment().format("HH:mm");
    this._timeCollect = timeField.value;
    $(timeField).trigger("change");
  },

  _deliverTimeChanged(ev) {
    /*
  let val = ev.target.value;
console.log("val: ",moment(val).format('HH:mm') );
  if (moment(val).format('HH:mm') == 'Invalid date') {
    console.log("invalid");
    this.getUI('timeDeliverField')[0].value = this._timeDeliver;
  } else {
    this.getUI('timeDeliverField')[0].value = moment(val).format('HH:mm');
    this._timeDeliver = moment(val).format('HH:mm');
  }*/
    this._orderTabChanged(ev);
  },

  _collectTimeChanged(ev) {
    /*
  let val = ev.target.value;

  if (moment(val).format('HH:mm') == 'Invalid date') {
    this.getUI('timeCollectField')[0].value = this._timeCollect;
  } else {
    this.getUI('timeCollectField')[0].value = moment(val).format('HH:mm');
    this._timeCollect = moment(val).format('HH:mm');
  }*/
    this._orderTabChanged(ev);
  },

  //------------------------------------------------------------------ render ---------------------------------------------------//

  _render() {
    const context = this,
      requests = {};

    if (typeof context._requestsInProgress !== "undefined") {
      return;
    }

    this._requestsInProgress = true;

    /*
      On first access, get user who created and user who modified current order
      make it available in template and delete variables later
      handle deleted users (unknown user)
     */

    let c = 0;

    const onRequestsFinished = function () {
      // Check whether all requests are finished, then render

      if (c++ === _.size(requests)) {
        delete context._requestsInProgress;

        context.user = new User(context.model.get("user"));

        context.render();

        if (typeof context.options.afterRender !== "undefined") {
          context.options.afterRender(context);
        }
      }
    };

    // Fetch order.user_id ("customer")
    if (
      this.model.get("user_id") !== "" &&
      this.model.get("user_id") !== null &&
      typeof this.users.get(this.model.get("user_id")) === "undefined"
    ) {
      requests.user_id = true;

      this.users.fetchById(this.model.get("user_id"), function () {
        // User now selectable in users-list
        onRequestsFinished();
      });
    }

    onRequestsFinished(); // Eventually, no requests had to be fired -> render view!
  },

  // Also used in QuickOrderForm.js:
  _dependencies: {
    users: new Users(),
    contingents: new Contingents(),
    voucherTypes: new VoucherTypes(),
    vouchers: new Vouchers(),
  },

  initialize() {
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;
    const moduleSelected = searchParams.get("type");
    const that = this;
    let orderID = this.model.id;

    // get order id from url if not set yet
    if (orderID == null || orderID == "") {
      orderID = location.href.split("/edit")[0];
      if (orderID.indexOf("reservationsList") >= 0) orderID = orderID.split("reservationsList/")[1];
      if (orderID.indexOf("orders") >= 0) orderID = orderID.split("orders/")[1];
    }
    // fetch order tasks
    const RequestHelper = Backbone.Model.extend({
      urlRoot: "/tasks?includes=Users&fk_model=Orders&fk_id=" + orderID,
    });

    new RequestHelper(null).fetch({
      success(model, response) {
        if (response.success && response.data.length > 0) {
          // put tasks into list of tasks
          that._tasks = [];
          for (var i = 0; i < response.data.length; i++) {
            that._tasks.push(response.data[i]);
          }
          that.render();
        } else {
          console.log("ERROR: failed to get tasks response or no tasks available");
        }
      },
      error(model, response) {
        console.log("Error, could not request tasks.");
      },
    });

    // temp data for order tags
    this._tagRequestStarted = false;
    this._availableTags = [];
    this._selectedTags = [];
    this._customTagsCount = 0;

    if (typeof this.options.context != "undefined") {
      moduleSelected === "bookings"
        ? (this.parentView = "/reservations/reservationsList" + currentUrl.search)
        : moduleSelected === "orders"
          ? (this.parentView = "/reservations/orders" + currentUrl.search)
          : (this.parentView = "/reservations/orders" + currentUrl.search);
    }

    new Dependencies(this._dependencies).then(() => {
      that.users = Radio.channel("users").request("get:data");

      if (typeof Radio._channels["dynamo_start_locations"] !== "undefined") {
        that._render();
      } else {
        that.initDynamoDB(function () {
          that._render();
        });
      }
    });

    if (this.model.get("id") !== "" && this.model.get("price").indexOf("0,00") >= 0) {
      // Coming from quickOrderForm, we need to fetch new total order price
      this.model.updatePrice();
    }

    // catch key events
    document.onkeydown = function (ev) {
      let isEscape = false;
      ev = ev || window.event;

      if ("key" in ev) {
        isEscape = ev.key === "Escape" || ev.key === "Esc";
      } else {
        isEscape = ev.keyCode === 27;
      }
      if (isEscape) {
        console.log("escape: ", that._form);
        var controls = that._form.controls;
        for (var i = 0; i < controls.length; i++) {
          if (controls[i].el.className.indexOf("user_id") >= 0 && controls[i].input.isOpen()) {
            controls[i].input.close();
          }
        }
      }
    };
  },

  initDynamoDB(callback = null) {
    const that = this;

    DynamoDB.getAllLocations(Number(Biscuit.get("user.client_id")), false, null, "small").then(
      function (data) {
        const channel = Radio.channel("dynamo_start_locations"),
          collection = new Backbone.Collection(data.Items);

        let begin_locations = [
          {
            label: "- Found no location -",
            value: "",
          },
        ];

        if (typeof data.Items[0] !== "undefined") {
          let managerHasLocations = Biscuit.get("user.user_locations");

          if (managerHasLocations !== "") {
            managerHasLocations = managerHasLocations.split(",");
          }

          begin_locations = [];
          _.each(data.Items, (location) => {
            let locationIdStr = "";
            locationIdStr = location.begin_location_id.toString();

            if (
              typeof that.model == "undefined" &&
              managerHasLocations.length &&
              !_.contains(managerHasLocations, locationIdStr)
            ) {
              return;
            }

            begin_locations.push({
              label: location.name,
              value: location.begin_location_id,
            });
          });
        }

        begin_locations = _.sortBy(begin_locations, (location) => location.label);

        channel.reply("get:data", function () {
          // Finally: save data for later use
          // This channel could be used in future to
          // override locations-channel of regular API
          return collection;
        });

        channel.reply("get:data:list", function () {
          return begin_locations;
        });

        channel.on("fetchBeginLocation", function (model, callback = null) {
          // Get all details for the selected pick up location
          DynamoDB.getLocationEntity(
            model.get("begin_location"),
            Number(Biscuit.get("user.client_id")),
          ).then(function (data) {
            if (typeof data.Items[0] !== "undefined") {
              let location = collection.find({
                begin_location_id: model.get("begin_location"),
              });

              if (typeof location == "undefined") {
                // Approach to fix a bug on live regarding corrupt data
                location = collection.find({
                  begin_location_id: model.get("begin_location").toString(),
                });
              }

              if (typeof location == "undefined") {
                console.log(
                  "Found no location for",
                  model.get("begin_location"),
                  collection.models,
                );
              } else {
                location.set(data.Items[0]);
                model.trigger("change:begin");
                //  model.trigger('change:end');
              }

              if (callback) {
                callback();
              }
            }
          });
        });

        channel.reply("getLocationById", function (location_id) {
          // Iterates over locations-collection, searches for location_id

          location_id = Number(location_id);

          const locations = channel.request("get:data");
          let location = locations.find({ begin_location_id: location_id });

          if (
            typeof location !== "undefined" &&
            typeof location.get("check_in_periods") !== "undefined"
          ) {
            return location;
          } else {
            location = null;
          }

          _.each(locations.models, (_location) => {
            // @todo Performance: use native for-loop in order to use break; / continue;

            if (location !== null) return;

            _.each(_location.get("end_locations"), (__location, __location_id) => {
              if (location !== null) return;

              if (__location_id == location_id) {
                __location.begin_location_id = __location_id; // For A/B rentals
                location = new Backbone.Model(__location);
              }
            });
          });

          return location;
        });

        if (callback) {
          callback();
        }
      },
    );
  },

  onRender() {
    const that = this;

    $(".appointment-dropdown.is-open").trigger("close"); // e.g. .appointment-dropdown

    let allNonAdminUsers = [];

    _.each(this.users.models, (user) => {
      if (typeof that.user !== "undefined" ? user.get("id") == that.user.get("id") : false) {
        allNonAdminUsers.push({
          label: user.get("first_name") + " " + user.get("last_name"),
          value: user.get("id"),
        });
      }
    });

    this._destroyDatepickers();

    this.datepickerDeliver = new Datepicker({
      i18n: Inboomai18n.getPikadayI18n(),
      firstDay: 1, // monday
      field: this.getUI("dateDeliverField")[0],
      trigger: this.getUI("dateDeliverField")[0],
      defaultDate: new Date(),
      onSelect: (date) => {
        that._datePickerDeliverOnSelect(date);
      },
    });

    this.datepickerCollect = new Datepicker({
      i18n: Inboomai18n.getPikadayI18n(),
      firstDay: 1, // monday
      field: this.getUI("dateCollectField")[0],
      trigger: this.getUI("dateCollectField")[0],
      defaultDate: new Date(),
      onSelect: (date) => {
        that._datePickerCollectOnSelect(date);
      },
    });

    let fields = [
      {
        label: this.t("user"),
        name: "user_id",
        control: "inboomaselect",
        collection: "users",
        sortBy: "created",
        sortDirection: "desc",
        placeholder: this.t("select_${a}", { a: this.t("user") }),
        advancedUserList: false,
        listItemContent: (model) => {
          /*        if (typeof model.get('role') !== 'undefined' && model.get('role') === 'admin') {
              return '';
            }*/

          return (
            model.get("first_name") +
            " " +
            model.get("last_name") +
            (model.get("deleted") !== null && model.get("deleted") !== ""
              ? " (" + that.t("customer_removed") + ")"
              : "")
          );
        },
        size: {
          large: "4",
          small: "6",
        },
      },
    ];

    if (that.model.get("id") !== "") {
      // Force formatting
      this.model.set("price", this.model.get("price"));

      fields.push(
        {
          name: "status",
          label: this.t("status"),
          control: "select",
          size: {
            large: "3",
            small: "6",
          },
          extraTopClasses: ["above-1", "min-height"],
          options: [
            { label: that.t("requested", null, "capital"), value: "requested" },
            { label: that.t("confirmed", null, "capital"), value: "confirmed" },
            {
              label: that.t("authorized", null, "capital"),
              value: "authorized",
              disabled: true,
            },
            {
              label: that.t("payment_pending", null, "capital"),
              value: "pending",
              disabled: true,
            },
            { label: that.t("paid", null, "capital"), value: "paid" },
            { label: that.t("cancelled", null, "capital"), value: "cancelled" },
          ],
        },
        {
          // formatter: Number(event.price).toLocaleString("es-ES", {minimumFractionDigits: 2})
          name: "total_price",
          label: this.t("total_price"),
          disabled: true,
          control: "input",
          size: {
            large: "2",
            small: "6",
          },
        },
      );
      if (Biscuit.get("client.show_usage_types") == "true") {
        fields.push({
          name: "types",
          label: this.t("types"),
          control: "select",
          size: {
            large: "3",
            small: "6",
          },
          extraTopClasses: ["above-1", "min-height"],
          options: [
            {
              label: that.t("usage_type_booking", null, "capital"),
              value: "booking",
            },
            {
              label: that.t("usage_type_service", null, "capital"),
              value: "service",
            },
            {
              label: that.t("usage_type_official", null, "capital"),
              value: "official",
            },
          ],
        });
      }
    }

    this._form = new Backform.Form({
      el: this.getUI("ordersForm"),
      model: this.model,
      fields,
    }).render();

    if (this.model.get("id") !== "") {
      _.each(this.model.get("reservations").models, function (reservation) {
        that._setReservationEvents(reservation);
      });

      this._reservationsList = new ReservationsList({
        el: this.getUI("reservationsListRegion"),
        collection: this.model.get("reservations"),
        toggleReservation: that.options.toggleReservation,
        parent: this.model,
      });
    }

    // Prevent multiple calls on change:status
    this.model._statusChangeInProgress = false;

    this._setVCard();

    if (this.model.get("id") != "" && !this.model.get("reservations").length) {
      this.options.toggleAddReservation = true;
    }

    if (this.options.toggleAddReservation) {
      this._addReservation();
    }

    this._toggleHideExecuteBtn();

    this._recalculateOrderPrice();

    this._setAddressCountries();
    this._updateOrderAddresses();

    if (!this._tagRequestStarted) {
      this._tagRequestStarted = true;
      this._requestAvailableTags();
    } else this._setAvailableTags();

    // check for user duplicates
    var controls = this._form.controls;
    for (var i = 0; i < controls.length; i++) {
      if (controls[i].el.className.indexOf("user_id") >= 0) {
        controls[i].input.checkForDuplicates();
        // also add link to user profile
        for (var j = 0; j < controls[i].el.childNodes.length; j++) {
          if (
            controls[i].el.childNodes[j].tagName == "LABEL" &&
            this.user.get("id") !== undefined &&
            this.user.get("id") != null
          ) {
            var label = controls[i].el.childNodes[j];
            label.style = "min-width: 90px"; // workaround for backform style issue: setting min width for label manually
            var userLink = document.createElement("a");
            userLink.setAttribute("href", "/users/" + this.user.get("id"));
            var infoIcon = document.createElement("i");
            infoIcon.className = "fi fi-torso";
            infoIcon.title = this.t("orders_form_user_link_info");
            infoIcon.style = "display: inline-flex;height:18px;margin-left: 5px;color:#EB6A3A;";
            var vcardLink = document.createElement("a");
            vcardLink.id = "inb-order-vcard-link";
            vcardLink.addEventListener("click", this._toggleVCard);
            const vcardCloseBtn = document.getElementById("inb-vcard-close-btn");
            if (vcardCloseBtn) {
              vcardCloseBtn.addEventListener("click", this._toggleVCard);
            }
            var userInfoBoxIcon = document.createElement("i");
            userInfoBoxIcon.className = "fi fi-info";
            userInfoBoxIcon.title = this.t("user_vcard_info");
            userInfoBoxIcon.style =
              "height: 18px;line-height: 18px;color: #EB6A3A;margin-left: 8px;";
            userLink.appendChild(infoIcon);
            vcardLink.appendChild(userInfoBoxIcon);
            label.appendChild(userLink);
            label.appendChild(vcardLink);
            //label.classList.add("inb-form-label-with-link");
          }
        }
      }
    }
  },

  _toggleVCard() {
    const vcard = document.getElementById("order-vcard");
    if (vcard.classList.contains("hide")) {
      vcard.classList.remove("hide");
    } else {
      vcard.classList.add("hide");
    }
  },

  _recalculateOrderPrice() {
    let price_value = this.model.get("price");
    price_value = price_value.replace(
      Biscuit.getClientCurrency(),
      " " + Biscuit.getClientCurrency(),
    );

    this.$("input[name=total_price]")[0].value = price_value;
  },

  /**
   * Called by event model.change:status
   * Tell API about changed order.status
   *
   * @todo Refactor -
   *       I) Which of these lines are actually required?
   *       Investigate whether this.render() could be made
   *       more performant using this._reservationsList.render();
   *       (even though reservations events are observed in ReservationsList,
   *        so there is not actual need to re-render)
   *       II) Consider that order status can also be changed in OrdersView.js
   *       -> there we would need the same logic like here (!DRY)
   *          -> Move functionality into model / model observer
   *
   * After Refactoring:
   *      Called only if model status really changed.
   *      Sync with Backend, show notification?
   */
  _changeOrderStatus(ev) {
    // event has already been handled by execute order
    if (this._alreadyExecuted) {
      this._alreadyExecuted = false;
      return;
    }

    const val = this.model.get("status"),
      that = this;

    this.model.save(
      { status: val },
      {
        patch: true,
        silent: true,
        success() {
          that.model._statusChangeInProgress = false;
          that.model.trigger("changed");
          that._render();
        },
      },
    );

    this.render();

    new Notification({
      message: this.t("updated_${a}", { a: this.t("order") }, "capital"),
      duration: 9000,
      type: "success",
      closeable: true,
      icon: "fi fi-check",
    });
  },

  _changeOrderTypes(ev) {
    const val = this.model.get("types"),
      that = this;

    this.model.save(
      { types: val },
      {
        patch: true,
        silent: true,
        success() {
          that.model._statusChangeInProgress = false;
          that.model.trigger("changed");
          that._render();
        },
      },
    );

    this.render();

    new Notification({
      message: this.t("updated_${a}", { a: this.t("order") }, "capital"),
      duration: 9000,
      type: "success",
      closeable: true,
      icon: "fi fi-check",
    });
  },

  /**
   * Tell API about changed order.user_id
   */
  _changeOrderUser() {
    if (this.model._statusChangeInProgress) {
      return;
    }

    this.model._statusChangeInProgress = true;

    const that = this,
      val = this.model.get("user_id");

    if (this.model.get("id") && val !== "") {
      this.model.save(
        { user_id: val },
        {
          patch: true,
          silent: true,
          success() {
            that.model._statusChangeInProgress = false;
            that.user = that.users.get(val);
            that.model.set("user", that.user.toJSON());
            that.model.trigger("changed");
            // change invoice address according to user (this will trigger update of form) [#21943]
            // delete old address
            for (var i = 0; i < that.model.attributes.order_addresses.length; i++) {
              if (that.model.attributes.order_addresses[i].type == "invoice")
                that.model.attributes.order_addresses.splice(i, 1);
            }
            // update form data with new user address, set address status to 'unsaved'
            that._updateOrderAddresses();
            for (i = 0; i < that._orderTabs.length; i++) {
              if (that._orderTabs[i].id == "order-form-invoice-address-edit")
                that._orderTabs[i].saved = false;
            }
            // find save button of invoice address and trigger event
            $(document.getElementById("order-form-invoice-address"))
              .find(".inb-order-form-address-save")
              .trigger("click");
          },
        },
      );

      new Notification({
        message: this.t("updated_${a}", { a: this.t("order") }, "capital"),
        duration: 9000,
        type: "success",
        closeable: true,
        icon: "fi fi-check",
      });
    }
  },
});
